export default {
  path: 'subscription/thankyou',
  getComponent(nextState, done) {
    require.ensure([], require => {
      done(null, require('./thankYou').default);
    });
  },
};



// WEBPACK FOOTER //
// ./src/routes/subscription/route.js